import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { nanoid } from 'nanoid';

import { ItemRenderer, ListProps } from './types';

const StyledContainer = styled.div``;

const StyledHeader = styled.div``;

const StyledContent = styled.div``;

const StyledItemWrapper = styled.div<Pick<ListProps, 'itemSeparation'>>`
  &:not(:last-child) {
    margin-bottom: ${({ itemSeparation }) => itemSeparation}px;
  }
`;

const StyledDefaultItem = styled.span``;

const renderDefaultItem: ItemRenderer = (item) => (
  <StyledDefaultItem>{item}</StyledDefaultItem>
);

const renderItems = (
  items: ListProps['items'],
  itemIndexes: string[],
  renderItem: ListProps['renderItem'] = renderDefaultItem,
  onItemClick: ListProps['onItemClick'],
  itemWrapperClassName: ListProps['itemWrapperClassName'],
  itemSeparation: ListProps['itemSeparation'],
) => items.map((item, index) => (
  <StyledItemWrapper
    key={itemIndexes[index]}
    className={itemWrapperClassName}
    onClick={onItemClick}
    itemSeparation={itemSeparation}
  >
    {renderItem(item)}
  </StyledItemWrapper>
));

const List = ({
  items,
  title,
  renderItem,
  onItemClick,
  className,
  headerClassName,
  contentClassName,
  itemWrapperClassName,
  itemSeparation = 4,
}: ListProps) => {
  const [itemIndexes, setItemIndexes] = useState<string[]>([]);

  useEffect(() => {
    const idxs: string[] = [];

    items.forEach(() => {
      idxs.push(nanoid());
    });

    setItemIndexes(idxs);
  }, []);

  return (
    <StyledContainer className={className}>
      {title && (
        <StyledHeader className={headerClassName}>{title}</StyledHeader>
      )}
      <StyledContent className={contentClassName}>
        {renderItems(items, itemIndexes, renderItem, onItemClick, itemWrapperClassName, itemSeparation)}
      </StyledContent>
    </StyledContainer>
  );
};

export default List;
